export default __webpack_public_path__ + "static/media/Discover Serenity Now.436f5360.svg";